<template>
  <div class="car">
    <!-- title -->
    <el-row>
      <el-col :span="24" :xs="24" class="car-title">
        {{ $t("usedcar-search-title") }}</el-col
      >
    </el-row>
    <el-row>
      <el-col :span="24" :xs="24" class="car-title2">
        {{ $t("usedcar-search-description") }}</el-col
      >
    </el-row>
    <!-- 检索条件 -->
    <div class="car-content">
      <div class="car-content2">
        <el-row style="padding-bottom: 20px" justify="center">
          <el-col :span="12" :xs="24" class="car-mobile-bottom">
            <!-- メーカー -->
            <el-row>
              <el-col :span="8" :xs="8" class="car-condition-lable">{{
                $t("usedcar-search-manufacturer")
              }}</el-col>
              <el-col :span="16" :xs="16">
                <el-select
                  v-model="conditions.manufacturer"
                  size="large"
                  style="width: 100%"
                  @change="getModelList"
                  :empty-values="[null, undefined]"
                  :value-on-clear="null"
                >
                  <el-option
                    v-for="item in manufacturerList"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  /> </el-select
              ></el-col>
            </el-row>
          </el-col>
          <el-col :span="12" :xs="24">
            <!-- 車種 -->
            <el-row>
              <el-col :span="6" :xs="8" class="car-condition-lable">
                {{ $t("usedcar-search-type") }}
              </el-col>
              <el-col :span="12" :xs="16">
                <el-select
                  v-model="conditions.model"
                  size="large"
                  style="width: 100%"
                  :empty-values="[null, undefined]"
                  :value-on-clear="null"
                >
                  <el-option
                    v-for="item in modelList"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  /> </el-select
              ></el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row style="padding-bottom: 20px">
          <el-col :span="12" :xs="24" class="car-mobile-bottom">
            <!-- 年份 -->
            <el-row>
              <el-col :span="8" :xs="8" class="car-condition-lable">{{
                $t("usedcar-search-year")
              }}</el-col>
              <el-col :span="16" :xs="16">
                <el-select
                  v-model="conditions.year"
                  size="large"
                  style="width: 100%"
                  :empty-values="[null, undefined]"
                  :value-on-clear="null"
                >
                  <el-option
                    v-for="item in yearList"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  /> </el-select
              ></el-col>
            </el-row>
          </el-col>
          <el-col :span="12" :xs="24">
            <!-- 价格 -->
            <el-row>
              <el-col :span="6" :xs="8" class="car-condition-lable">{{
                $t("price-range")
              }}</el-col>
              <el-col :span="8" :xs="16">
                <el-select
                  v-model="conditions.priceFrom"
                  size="large"
                  style="width: 100%"
                  :empty-values="[null, undefined]"
                  :value-on-clear="null"
                >
                  <el-option
                    v-for="item in priceList"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  /> </el-select
              ></el-col>
              <el-col :xs="8" class="car-mobile-dis"></el-col>
              <el-col :span="1" :xs="16">〜</el-col>
              <el-col :xs="8" class="car-mobile-dis"></el-col>
              <el-col :span="8" :xs="16">
                <el-select
                  v-model="conditions.priceTo"
                  size="large"
                  style="width: 100%"
                  :empty-values="[null, undefined]"
                  :value-on-clear="null"
                >
                  <el-option
                    v-for="item in priceList"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  /> </el-select
              ></el-col>
            </el-row>
          </el-col>
        </el-row>

        <el-row>
          <!--  -->
          <el-col :span="4" :xs="8" class="car-condition-lable">
            {{ $t("other-txt-04") }}
          </el-col>
          <el-col
            :span="20"
            :xs="16"
            class="car-list-table-right car-table-bottom-mobile"
            style="padding-left: 0px"
          >
            <el-radio-group v-model="conditions.sold_out_flg" size="medium">
              <el-radio label="2" > {{ $t("other-txt-01") }}</el-radio>
              <el-radio label="0" > {{ $t("other-txt-02") }}</el-radio>
              <el-radio label="1" > {{ $t("other-txt-03") }}</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>

        <el-row justify="center" style="padding-top: 60px">
          <el-button size="large" class="contact-btn" @click="search()">{{
            $t("search-button")
          }}</el-button>

          <el-button
            size="large"
            class="contact-goback-btn"
            @click="clealAll()"
            >{{ $t("clear-button") }}</el-button
          >
        </el-row>
      </div>
    </div>
    <!-- list -->
    <div class="car-list">
      <el-row class="car-list-title">
        <el-col :span="24" :xs="24">
          {{ $t("usedcar-list-title") }}
        </el-col>
      </el-row>
      <!-- v-infinite-scroll -->
      <el-row
        v-for="car in carList"
        :key="car.management_number"
        class="car-list-item-title"
      >
        <el-col :span="24" :xs="24">
          <!-- id + type -->
          <el-row>
            <el-col :span="24" :xs="24" style="line-height: 30px">
              <span> [{{ car.management_number }}]</span>
              <span style="padding-left: 10px">{{
                getCarTypeName(car.type)
              }}</span>
            </el-col>
          </el-row>
          <el-row>
            <!-- img -->
            <el-col :span="12" :xs="24" style="position: relative">
              <el-image
                :src="car.img"
                fit="cover"
                alt="Car Image"
                class="car-img"
              ></el-image>
              <el-image
                style="position: absolute; right: 8px; top: 8px; height: 100px"
                v-if="car.soldOutFlg === '1'"
                :src="require('@/assets/sold-out-png-19955.png')"
                fit="cover"
                alt="Car Image"
              ></el-image>
            </el-col>
            <!-- table -->
            <el-col
              :span="12"
              :xs="24"
              class="car-table"
              style="position: relative"
            >
              <el-row class="car-table-row-bottom">
                <!-- メーカー   -->
                <el-col
                  :span="4"
                  :xs="8"
                  class="car-list-table-left car-table-bottom-mobile"
                >
                  {{ $t("usedcar-search-manufacturer") }}
                </el-col>
                <el-col
                  :span="20"
                  :xs="16"
                  class="car-list-table-right car-table-bottom-mobile"
                >
                  {{ getCarManufacturerName(car.manufacturer) }}
                </el-col>
              </el-row>
              <el-row class="car-table-row-bottom">
                <!-- 型式 -->
                <el-col
                  :span="4"
                  :xs="8"
                  class="car-list-table-left car-table-bottom-mobile"
                >
                  {{ $t("usedcar-model") }}
                </el-col>
                <el-col
                  :span="8"
                  :xs="16"
                  class="car-list-table-right car-table-bottom-mobile"
                >
                  {{ car.model }}
                </el-col>
                <!-- 価格 -->
                <el-col
                  :span="4"
                  :xs="8"
                  class="car-list-table-left car-table-bottom-mobile"
                >
                  {{ $t("usedcar-list-price") }}
                </el-col>
                <el-col
                  :span="8"
                  :xs="16"
                  class="car-list-table-right car-table-bottom-mobile"
                >
                  <span v-html="car.price"></span>
                </el-col>
              </el-row>
              <el-row class="car-table-row-bottom">
                <!-- グレード -->
                <el-col
                  :span="4"
                  :xs="8"
                  class="car-list-table-left car-table-bottom-mobile"
                >
                  {{ $t("usedcar-grade") }}
                </el-col>
                <el-col
                  :span="8"
                  :xs="16"
                  class="car-list-table-right car-table-bottom-mobile"
                >
                  {{ car.grade }}
                </el-col>
                <!-- 年式 -->
                <el-col
                  :span="4"
                  :xs="8"
                  class="car-list-table-left car-table-bottom-mobile"
                >
                  {{ $t("usedcar-year") }}
                </el-col>
                <el-col
                  :span="8"
                  :xs="16"
                  class="car-list-table-right car-table-bottom-mobile"
                >
                  {{ car.year }}
                </el-col>
              </el-row>
              <el-row class="car-table-row-bottom">
                <!-- 色 -->
                <el-col
                  :span="4"
                  :xs="8"
                  class="car-list-table-left car-table-bottom-mobile"
                >
                  {{ $t("usedcar-list-color") }}
                </el-col>
                <el-col
                  :span="8"
                  :xs="16"
                  class="car-list-table-right car-table-bottom-mobile"
                >
                  {{ car.color }}
                </el-col>
                <!-- 車検 -->
                <el-col
                  :span="4"
                  :xs="8"
                  class="car-list-table-left car-table-bottom-mobile"
                >
                  {{ $t("usedcar-inspection") }}
                </el-col>
                <el-col
                  :span="8"
                  :xs="16"
                  class="car-list-table-right car-table-bottom-mobile"
                >
                  {{ car.inspection }}
                </el-col>
              </el-row>
              <el-row class="car-table-row-bottom">
                <!-- 走行距離 -->
                <el-col
                  :span="4"
                  :xs="8"
                  class="car-list-table-left car-table-bottom-mobile"
                >
                  {{ $t("usedcar-mileage") }}
                </el-col>
                <el-col
                  :span="8"
                  :xs="16"
                  class="car-list-table-right car-table-bottom-mobile"
                >
                  {{ car.mileage }}
                </el-col>
                <!-- 評価点 -->
                <el-col
                  :span="4"
                  :xs="8"
                  class="car-list-table-left car-table-bottom-mobile"
                >
                  {{ $t("usedcar-evaluation") }}
                </el-col>
                <el-col
                  :span="8"
                  :xs="16"
                  class="car-list-table-right car-table-bottom-mobile"
                >
                  {{ car.evaluation }}
                </el-col>
              </el-row>
              <el-button
                size="large"
                class="contact-btn car-table-btn"
                @click="goToCarInfo(car.management_number)"
                >{{ $t("usedcar-list-details-btn") }}</el-button
              >
            </el-col>
          </el-row>
          <el-divider />
        </el-col>
      </el-row>
    </div>
    <div v-if="loadmoreFLg" class="loading-text">Loading...</div>
    <div v-if="noMoreData" class="no-more-text">No more data</div>
  </div>
</template>

<script>
import { ref, onMounted, watch, onUnmounted } from "vue";
import { useI18n } from "vue-i18n";
import {
  generateYearListDesc,
  generatePriceList,
  formatYearMonth,
  formatMileage,
  formatMileage2,
  formatDisplacement,
  formatToYen,
  formatToYen2,
  formatYearMonthDay,
  isEmpty,
} from "@/utils/utils";
import { useRouter } from "vue-router";
import { ElLoading } from "element-plus";
import { supabase } from "@/supabase.js";

export default {
  setup() {
    const { locale, t } = useI18n();
    const router = useRouter();
    // メーカーlist
    const manufacturerList = ref([]);
    // 車種list
    const modelList = ref([{}]);
    // 車種list
    const modelList2 = ref([]);
    // 年份list
    const yearList = ref([]);
    // 价格list
    const priceList = ref([]);

    // car list
    const carList = ref([]);
    const carListTmp = ref([]);
    // const allListTmp = ref([]);

    const currentPage = ref(1); // 当前页数
    const pageSize = ref(10); // 每页显示多少条数据
    const totalPages = ref(0); // 总页数
    const noMoreData = ref(false);
    const loadmoreFLg = ref(false);

    // 查询条件
    const conditions = ref({
      manufacturer: "", // メーカー
      model: "", // 車種
      year: "", // 年份
      priceFrom: "", // 价格from
      priceTo: "", // 价格to
      sold_out_flg: "0", //  1: 售出, 0: 在售
    });

    const getManuList = async () => {
      //取得厂商列表
      try {
        const { data, error } = await supabase
          .from("manufacturer_m")
          .select("code, name_ja, name_en"); // 获取 code 和 name 字段

        if (error) {
          console.error("Error fetching data:", error);
        } else {
          manufacturerList.value = [];
          manufacturerList.value = data.map((item) => ({
            name: item[`name_${locale.value}`], // 动态根据语言选择字段
            code: item.code,
          }));
          // 在最前面添加 "指定なし" / "No preference"（从多语言文件获取）
          manufacturerList.value.unshift({
            name: t("not-selected"), // 从多语言文件中读取 "指定なし"
            code: "",
          });
        }
      } catch (err) {
        console.error("Unexpected error:", err);
      }
    };

    const getModelList = async () => {
      modelList.value = [];
      if (conditions.value.manufacturer !== "") {
        try {
          const { data, error } = await supabase
            .from("model_m")
            .select("code, name_ja, name_en") // 获取 code 和 name 字段
            .eq("m_code", conditions.value.manufacturer);
          if (error) {
            console.error("Error fetching data:", error);
          } else {
            modelList.value = data.map((item) => ({
              name: item[`name_${locale.value}`], // 动态根据语言选择字段
              code: item.code,
            }));
          }
        } catch (err) {
          console.error("Unexpected error:", err);
        }
      } else {
        modelList.value = [];
        conditions.value.model = "";
      }

      // 在最前面添加 "指定なし" / "No preference"（从多语言文件获取）
      modelList.value.unshift({
        name: t("not-selected"), // 从多语言文件中读取 "指定なし"
        code: "",
      });
    };

    const getModelList2 = async () => {
      modelList2.value = [];

      try {
        const { data, error } = await supabase
          .from("model_m")
          .select("code, name_ja, name_en"); // 获取 code 和 name 字段
        if (error) {
          console.error("Error fetching data:", error);
        } else {
          modelList2.value = data.map((item) => ({
            name: item[`name_${locale.value}`], // 动态根据语言选择字段
            code: item.code,
          }));
        }
      } catch (err) {
        console.error("Unexpected error:", err);
      }
    };

    const getCarTypeName = (code) => {
      console.log("code:" + code);
      const carType = modelList2.value.find((t) => t.code == code);
      return carType ? carType.name : "-"; // 如果找不到就返回 "-"
    };

    const getCarManufacturerName = (code) => {
      console.log("code:" + code);
      const manufacturer = manufacturerList.value.find((t) => t.code == code);
      return manufacturer ? manufacturer.name : "-"; // 如果找不到就返回 "-"
    };

    const getAllList = async () => {
      yearList.value = generateYearListDesc().map((year) => ({
        name: `${year}`,
        code: `${year}`,
      }));
      // 在最前面添加 "指定なし" / "No preference"（从多语言文件获取）
      yearList.value.unshift({
        name: t("not-selected"), // 从多语言文件中读取 "指定なし"
        code: "",
      });
      priceList.value = generatePriceList(locale.value).map((item) => ({
        name: item[`name_${locale.value}`], // 动态根据语言选择字段
        code: item.code, // 这里固定使用 `item_ja` 作为 code
      }));
      // 在最前面添加 "指定なし" / "No preference"（从多语言文件获取）
      priceList.value.unshift({
        name: t("not-selected"), // 从多语言文件中读取 "指定なし"
        code: "",
      });
    };

    const search = async () => {
      // 开启 loading 动画
      const loading = ElLoading.service({
        lock: true,
        text: "Loading...",
        background: "rgba(0, 0, 0, 0.7)",
      });
      currentPage.value = 1;
      carList.value = [];
      noMoreData.value = false;
      let query = supabase.from("car_info").select("*");

      console.log("conditions.value.type:", conditions.value.type);
      if (conditions.value.manufacturer) {
        query = query.eq("manufacturer", conditions.value.manufacturer);
      }
      if (conditions.value.model) {
        query = query.eq("type", conditions.value.model);
      }
      if (conditions.value.year) {
        query = query.like("year_ja", `${conditions.value.year}%`);
      }
      if (conditions.value.priceFrom) {
        if (locale.value === "ja") {
          query = query.gte("price_ja", conditions.value.priceFrom);
        } else {
          query = query.gte("price_en", conditions.value.priceFrom);
        }
      }
      if (conditions.value.priceTo) {
        if (locale.value === "ja") {
          query = query.lte("price_ja", conditions.value.priceTo);
        } else {
          query = query.lte("price_en", conditions.value.priceTo);
        }
      }
      if (conditions.value.sold_out_flg !== "2") {
        query = query.eq("sold_out_flg", conditions.value.sold_out_flg);
      }

      // 分页
      const start = (currentPage.value - 1) * pageSize.value;
      const end = start + pageSize.value - 1;
      query = query.range(start, end);

      const { data, error } = await query;

      if (error) {
        loading.close();
        console.error("Error fetching data:", error);
        return;
      }

      carList.value = (data || []).map((item) => ({
        management_number: item.management_number, // 管理番号
        img: item.img,
        price: formatToYen2(item[`price_${locale.value}`], locale.value), // 価格
        manufacturer: item.manufacturer,
        type: item.type, // 車種
        year: formatYearMonth(item[`year_${locale.value}`], locale.value), // 年式
        mileage: formatMileage2(item[`mileage_${locale.value}`], locale.value), // 走行距離
        inspection: formatYearMonth(
          item[`inspection_${locale.value}`],
          locale.value
        ), // 車検
        evaluation: item[`evaluation_${locale.value}`], // 評価点
        grade: item[`grade_${locale.value}`], // グレード
        model: item[`model_${locale.value}`], // 型式
        color: item[`color_${locale.value}`], // カラー
        shift: item[`shift_${locale.value}`], // シフト
        drive_method: item[`drive_method_${locale.value}`], // 駆動方式
        turbo: item[`turbo_${locale.value}`], // 過給器
        displacement: formatDisplacement(item.displacement_ja), // 排気量
        points: item[`points_${locale.value}`], // ポイント
        publish_date: formatYearMonthDay(
          item[`publish_date_${locale.value}`],
          locale.value
        ), // 掲載日
        // management_number: item[`management_number_${locale.value}`], // 管理番号
        color: item[`color_${locale.value}`],
        soldOutFlg: item.sold_out_flg,
      }));

      if (carList.value.length > 0) {
        currentPage.value = currentPage.value + 1;
      }

      loading.close();
    };

    const loadmore = async () => {
      if (currentPage.value === 1) return;
      if (loadmoreFLg.value || noMoreData.value) return;
      // 开启 loading 动画
      const loading = ElLoading.service({
        lock: true,
        text: "Loading...",
        background: "rgba(0, 0, 0, 0.7)",
      });
      loadmoreFLg.value = true;
      let query = supabase.from("car_info").select("*");

      if (conditions.value.manufacturer) {
        query = query.eq("manufacturer", conditions.value.manufacturer);
      }
      if (conditions.value.model) {
        query = query.eq("type", conditions.value.model);
      }
      if (conditions.value.year) {
        query = query.like("year_ja", `${conditions.value.year}%`);
      }
      if (conditions.value.priceFrom) {
        if (locale.value === "ja") {
          query = query.gte("price_ja", conditions.value.priceFrom);
        } else {
          query = query.gte("price_en", conditions.value.priceFrom);
        }
      }
      if (conditions.value.priceTo) {
        if (locale.value === "ja") {
          query = query.lte("price_ja", conditions.value.priceTo);
        } else {
          query = query.lte("price_en", conditions.value.priceTo);
        }
      }
      if (conditions.value.sold_out_flg !== "2") {
        query = query.eq("sold_out_flg", conditions.value.sold_out_flg);
      }
      // 分页
      const start = (currentPage.value - 1) * pageSize.value;
      const end = start + pageSize.value - 1;
      query = query.range(start, end);

      const { data, error } = await query;

      if (error) {
        loading.close();
        loadmoreFLg.value = false;
        console.error("Error fetching data:", error);
        return;
      }
      let tmp = [];
      tmp = (data || []).map((item) => ({
        management_number: item.management_number, // 管理番号
        img: item.img,
        manufacturer: item.manufacturer,
        price: formatToYen(item[`price_${locale.value}`]), // 価格
        type: item.type, // 車種
        year: formatYearMonth(item[`year_${locale.value}`], locale.value), // 年式
        mileage: formatMileage(item.mileage_ja), // 走行距離
        inspection: formatYearMonth(
          item[`inspection_${locale.value}`],
          locale.value
        ), // 車検
        evaluation: item[`evaluation_${locale.value}`], // 評価点
        grade: item[`grade_${locale.value}`], // グレード
        model: item[`model_${locale.value}`], // 型式
        color: item[`color_${locale.value}`], // カラー
        shift: item[`shift_${locale.value}`], // シフト
        drive_method: item[`drive_method_${locale.value}`], // 駆動方式
        turbo: item[`turbo_${locale.value}`], // 過給器
        displacement: formatDisplacement(item.displacement_ja), // 排気量
        points: item[`points_${locale.value}`], // ポイント
        publish_date: formatYearMonthDay(
          item[`publish_date_${locale.value}`],
          locale.value
        ), // 掲載日
        // management_number: item[`management_number_${locale.value}`], // 管理番号
        color: item[`color_${locale.value}`],
        soldOutFlg: item.sold_out_flg,
      }));

      if (tmp.length > 0) {
        currentPage.value = currentPage.value + 1;
        carList.value.push(...tmp);
      } else {
        noMoreData.value = true;
      }
      loadmoreFLg.value = false;
      loading.close();
    };
    const clealAll = () => {
      conditions.value = {
        manufacturer: "", // メーカー
        model: "", // 車種
        year: "", // 年份
        priceFrom: "", // 价格from
        priceTo: "", // 价格to
      };
    };

    const goToCarInfo = (management_number) => {
      // const carInfo = carListTmp.value.find(
      //   (car) => car.management_number === management_number
      // );
      // console.log("management_number:"+management_number)
      localStorage.setItem("management_number", management_number);
      localStorage.setItem(
        "carList",
        JSON.stringify({
          carList: carList.value,
          currentPage: currentPage.value,
          conditions: conditions.value,
        })
      );
      router.push("/carInfo");
      // router.push({
      //   path: "/carInfo",
      //   query: { id: car.management_number },
      // });
    };
    // **监听滚动事件**
    const handleScroll = () => {
      if (loadmoreFLg.value || noMoreData.value) return;

      const scrollPosition = window.innerHeight + window.scrollY;
      const pageHeight = document.documentElement.scrollHeight;

      if (scrollPosition >= pageHeight - 50) {
        loadmore();
      }
    };

    onMounted(async () => {
      const from = localStorage.getItem("from");

      console.log("ssssss:");
      if (!isEmpty(from) && from === "carInfo") {
        const tmp = JSON.parse(localStorage.getItem("carList"));
        if (tmp) {
          carList.value = tmp.carList;
          currentPage.value = tmp.currentPage;
          conditions.value = tmp.conditions;
          localStorage.removeItem("carList");
          localStorage.removeItem("from");
        }
        // carList.value = tmp.carList;
        // currentPage.value = tmp.currentPage;
        // conditions.value = tmp.conditions;
        // localStorage.removeItem("carList");
        // localStorage.removeItem("from");
      }
      await getManuList();
      await getModelList();
      await getModelList2();
      await getAllList();
      search();
      window.addEventListener("scroll", handleScroll);
    });
    onUnmounted(() => {
      window.removeEventListener("scroll", handleScroll);
    });
    watch(locale, async () => {
      await getManuList();
      await getModelList();
      await getModelList2();
      await getAllList();
      search();
    });

    return {
      manufacturerList,
      modelList,
      yearList,
      priceList,
      conditions,
      carList,
      search,
      clealAll,
      goToCarInfo,
      getModelList,
      currentPage,
      totalPages,
      loadmore,
      loadmoreFLg,
      noMoreData,
      getCarTypeName,
      getCarManufacturerName,
    };
  },
};
</script>

<style scoped>
.car {
  padding: 0 50px;
}
.car-title {
  text-align: left;
  font-size: 50px;
  padding: 30px;
  padding-top: 60px;
}
.car-title2 {
  text-align: left;
  padding: 0 40px;
}
.car-content {
  padding-bottom: 40px;
  padding-top: 40px;
  background: linear-gradient(90deg, #e7f1f4 0%, #f0f3f4 100%);
  line-height: 40px;
  margin: 20px 40px;
}
.car-content2 {
  padding: 0px 60px;
}
.car-condition-lable {
  text-align: right;
  padding-right: 20px;
}
.car-mobile-dis {
  display: none;
}
.contact-btn {
  height: 50px;
  width: 200px;
  background-color: #1a5276;
  color: white;
}
.contact-goback-btn {
  height: 50px;
  width: 200px;
  background-color: #909399;
  color: white;
}

.contact-btn:hover {
  background-color: #56abe4;
  color: white;
}

.car-list {
  padding-top: 30px;
}
.car-list-title {
  background-color: rgb(26, 82, 118);
  color: white;
  height: 50px;
  line-height: 50px;
  padding: 0 20px;
}
.car-list-item-title {
  padding-top: 10px;
}
.car-img {
  min-height: 390px;
}
.car-table {
  padding-left: 5px;
}
.car-list-table-left {
  background-color: rgb(26, 82, 118);
  color: white;
  line-height: 40px;
  text-align: left;
  padding-left: 10px;
}
.car-list-table-right {
  background: linear-gradient(90deg, #e7f1f4 0%, #f0f3f4 100%);
  line-height: 40px;
  text-align: left;
  padding-left: 10px;
}
.car-table-row-bottom {
  padding-bottom: 2px;
}
.el-divider--horizontal {
  border-top: 1px var(--el-border-color) var(--el-border-style);
  display: block;
  height: 1px;
  margin: 24px 0;
  width: 100%;
  margin-bottom: 10px;
}
.car-table-btn {
  width: 40%;
  position: absolute;
  bottom: 10px;
  right: 10px;
}
.sold-out-banner {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 120px;
  height: 120px;
  background-color: red;
  color: white;
  font-size: 14px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  transform: rotate(45deg);
  clip-path: polygon(0 100%, 100% 100%, 100% 0);
}
.loading-text,
.no-more-text {
  text-align: center;
  padding: 10px;
}
@media (max-width: 768px) {
  .car {
    padding: 20px 20px 0px 20px;
  }
  .car-title {
    text-align: left;
    padding: 10px;
    font-size: 30px;
  }
  .car-content {
    margin: 0;
    margin-top: 10px;
    padding: 20px 20px;
    background: linear-gradient(90deg, #e7f1f4 0%, #f0f3f4 100%);
  }
  .car-content2 {
    padding: 0px;
  }
  .car-condition-lable {
    text-align: left;
    /* padding-right: 20px; */
  }
  .car-mobile-dis {
    display: block;
  }
  .car-mobile-bottom {
    padding-bottom: 20px;
  }
  .contact-btn {
    height: 50px;
    width: 130px;
    background-color: #1a5276;
    color: white;
  }
  .contact-goback-btn {
    height: 50px;
    width: 130px;
    background-color: #909399;
    color: white;
  }
  .car-list {
    padding-top: 20px;
  }
  .car-list-title {
    background-color: rgb(26, 82, 118);
    color: white;
    height: 40px;
    line-height: 40px;
    padding: 0 10px;
  }
  .car-img {
    min-height: auto;
  }
  .car-table {
    padding-left: 0px;
  }
  .car-table-bottom-mobile {
    margin-bottom: 2px;
  }
  .car-table-row-bottom {
    padding-bottom: 0px;
  }
  .car-table-btn {
    margin-top: 10px;
    width: 100%;
    position: unset;
  }
}
</style>
